import type { TabItem } from '@/components/custom/erp';
import { AccountInfoTab } from './AccountInfoTab';
import type { FormDialogModel } from './hooks';
import { DetailTab } from './DetailTab';
import { OtherTab } from './OtherTab';
import { HDDTTab } from './HDDTTab';

const scrollableTab = (content: React.ReactNode) => (
  <div className='h-full w-full min-w-0 overflow-y-auto pb-24'>{content}</div>
);

export const FormTabs = (dialog: FormDialogModel): TabItem[] => {
  if (dialog.activeTab !== 'info') return [];

  const tabs: TabItem[] = [
    {
      id: 'details',
      label: 'Chi tiết',
      component: (
        <DetailTab
          {...dialog.detail.tableProps}
          formMode={dialog.formMode}
          ck_yn={dialog.formState.state.ck_yn}
          loai_ck={dialog.formState.state.loai_ck}
          constraints={dialog.constraints}
        />
      )
    },
    {
      id: 'hddt',
      label: 'HĐĐT(Không sử dụng)',
      component: scrollableTab(<HDDTTab formMode={dialog.formMode} />)
    },
    {
      id: 'other',
      label: 'Khác',
      component: scrollableTab(<OtherTab formMode={dialog.formMode} formState={dialog.formState} />)
    }
  ];

  if (dialog.formState.state.pt_tao_yn && dialog.formState.state.ma_httt === 'KB') {
    tabs.push({
      id: 'account',
      label: 'Thông tin tài khoản',
      component: scrollableTab(
        <AccountInfoTab
          formMode={dialog.formMode}
          rows={dialog.account.rows}
          selectedRowUuid={dialog.account.selectedRowUuid}
          selectedCell={dialog.account.selectedCell}
          onRowClick={dialog.account.handleRowClick as BanHangRecord}
          onCellClick={dialog.account.handleCellClick as BanHangRecord}
          onAddRow={dialog.account.handleAddRow}
          onDeleteRow={dialog.account.handleDeleteRow}
          onCopyRow={dialog.account.handleCopyRow}
          onPasteRow={dialog.account.handlePasteRow}
          onMoveRow={dialog.account.handleMoveRow}
          onCellValueChange={dialog.account.handleCellValueChange}
          handleUpdateNonWritableFields={dialog.account.setNonWritableFields}
          handleUpdatePasteConfigs={dialog.account.setPasteConfigs}
          isPasting={dialog.account.isPasting}
        />
      )
    });
  }

  return tabs;
};
